import React, { useState } from "react";
import { Row, Col, Media, Fade } from "reactstrap";
import { mldInvest } from "../assets/constants/mld-invest";
import ImgPopup from "./ImgPopup";
import { isMobile } from "react-device-detect";
import PopUpSecondFold from "./PopUpSecondFold";
import InfoPopup from "./InfoPopup";

const SecondFold = (props) => {
    const [PopUpImg, setPopUpImg] = useState(false);
    const [imgSrc, setImgSrc] = useState();
    const [graphSrc, setGraphSrc] = useState()
    const [popUpGraph, setPopUpGraph] = useState(false);
    const [popUp, setPopUp] = useState(false);
    const [popUpsecondFold, setPopUpsecondFold] = useState(false);
    const [showPopUpHead, setShowPopUpHead] = useState(false);

    const popText =
  props.mldAssetDetails.bondId === "gmldm0" || props.mldAssetDetails.bondId === "gmld1"
    ? `<ol>
        <li> MCX near-month Futures gold prices from 23rd Oct 2008 to 28th May 2025 </li><br />
        <li> Total No of Observations = 4,694 </li><br />
        <li> ETF returns are based on the Month 1 Gold price (for purchase) and the Month 42 Gold Price (for sale) </li><br />
        <li> MLD returns are based on the Month 1-6 average Gold price (for purchase) and the Month 34-39 Gold Price (for sale) </li><br />
        <li> For computing the returns of MLD, an expense ratio of 0.5% p.a. is considered </li>
      </ol>`
    : `<ol>
        <li> The returns considered here are the average 2 Year returns of Nifty 50 Index taken from the days 
        when it has closed at an All-Time High. This is a set of 230 observation dates beginning from 1st Jan 2010 till 14th Jul 2021. </li><br /> 
        <li> Out of the 230 such All-Time High observations, 
        there have been 58 instances where Nifty has given a negative return in 2 years’ time. </li>
      </ol>`;

    const hyperDiv = {
        maxWidth: "max-content",
        marginRight: !props?.isMobile ? "auto" : ""
    }

    const hyperlink = {
        fontSize: "14px",
        color: "#3746A3",
        cursor: "pointer",
        textDecoration: "underline",
    }

    const hyperlinkSub = {
        fontSize: "18px",
        color: "#3746A3",
        cursor: "pointer",
        textDecoration:"underline"
    }

    const toggleImgPopUp = (src) => {
        setImgSrc(src)
        setPopUpImg(!PopUpImg)
    }

    const toggleGraphPopUp = (item) => {
        setGraphSrc(item)
        setPopUpGraph(!popUpGraph)
    }

    const toggleNiftyPopup = () => {
        setPopUp(!popUp)
    }

    const toggleSecondFold = () => {
        setPopUpsecondFold(!popUpsecondFold)
    }

    const handleHeadInfoClick = () => {
        setShowPopUpHead(!showPopUpHead)
    }

    return (
      (
        <>
          {props.mldAssetDetails.bondId === "mld3" ||
          props.mldAssetDetails.bondId === "mld4" ? (
            <div
              className={
                "w-100 stats-div " +
                (props?.fromBondsPage
                  ? "bg-color-mld"
                  : props?.fromMldPage
                  ? "bg-color-mld"
                  : "")
              }
            >
              <div className="section-max-width">
                <Col xs={12} lg={12} className="text-center">
                  <div className="info-block">
                    <Fade bottom="bottom" distance="50px">
                      <p className="block-title">{mldInvest.forthFold.title}</p>
                      <p className="block-subtitle">
                        {mldInvest.forthFold.subTitle}
                      </p>
                    </Fade>
                  </div>
                </Col>
                <div
                  className="stats-fold invest-option"
                  style={{ maxWidth: "100%" }}
                >
                  {mldInvest &&
                    mldInvest?.forthFold &&
                    mldInvest?.forthFold?.content.map((item) => (
                      <Col
                        lg={3}
                        sm={12}
                        xs={12}
                        md={12}
                        className="d-flex flex-column stats-col"
                      >
                        <Row className="align-items-center invest-option-row">
                          <Media
                            src={item.imgSrc}
                            alt="alt-asset"
                            className="cards-img"
                          />
                          <div className="d-flex flex-column align-items-center content ">
                            <div className="text-wrapper">
                              <p
                                className="subtext"
                                style={{ fontWeight: "800" }}
                              >
                                {item.text}
                              </p>
                            </div>
                            <p className="text">{item.subtext}</p>
                            {item.seeHow && (
                              <div style={hyperDiv}>
                                {props.mldAssetDetails.bondId === "mld3" ||
                                props.mldAssetDetails.bondId === "mld4" ? (
                                  <p
                                    style={hyperlink}
                                    onClick={() => {
                                      toggleImgPopUp(
                                        !isMobile
                                          ? item.popUpImg
                                          : item.mobileViewImage
                                      );
                                    }}
                                  >
                                    Click Here to See How
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            )}
                          </div>
                        </Row>
                      </Col>
                    ))}
                </div>

                {props?.showSecondDiv ? (
                  <div className="stats-fold">
                    <div>
                      {props.mldAssetDetails.bondId === "mld4" ? (
                        <p className="block-title">62%*</p>
                      ) : (
                        <p className="block-title">69%*</p>
                      )}
                      {props.mldAssetDetails.bondId === "mld4" ? (
                        <p className="block-subtitle text-center">
                          From All Time Highs, Enhanced MLD has outperformed the
                          Nifty 50 index on 62% of occasions.
                        </p>
                      ) : (
                        <p className="block-subtitle text-center">
                          1.5x Nifty MLD has outperformed Nifty 50 on 69%
                          occasions.
                        </p>
                      )}
                    </div>
                    <div>
                      {props.mldAssetDetails.bondId === "mld4" ? (
                        <p className="block-title">2.82x*</p>
                      ) : (
                        <p className="block-title">1.91x*</p>
                      )}
                      {props.mldAssetDetails.bondId === "mld4" ? (
                        <p className="block-subtitle text-center">
                          The Return per unit of risk for Nifty 50 is 1.89x
                          whereas the same for Enhanced MLD is 2.82x.
                        </p>
                      ) : (
                        <p className="block-subtitle text-center">
                          The Return per unit of risk for Nifty 50 is 1.22x
                          whereas the same for 1.5x Nifty MLD is 1.91x.
                        </p>
                      )}
                    </div>
                  </div>
                ) : null}

                {props?.showSecondDiv ? (
                  <div className="info-block">
                    <Fade bottom="bottom" distance="50px" className="px-4">
                      <p
                        className="d-flex flex-row text-center"
                        style={!props?.isMobile ? { padding: "1rem 3rem" } : {}}
                      >
                        *The returns for the Enhanced MLD and Nifty 50 Index are
                        based on back-tested data from 01-Jan-10 till 18-Jul-24
                        assuming daily investment. Back-testing/ past
                        performance is not an indication of future returns{" "}
                      </p>
                      {props.mldAssetDetails.bondId === "gmldm0" || props.mldAssetDetails.bondId === "gmld1" ? (
                        ""
                      ) : (
                        <p className="block-title">
                          Want to know how 100% Principal is protected at
                          Maturity? <br />
                          <span
                            onClick={() => {
                              toggleGraphPopUp(
                                !isMobile
                                  ? mldInvest.wantToKnowHowFold2.popUpImg
                                  : mldInvest.wantToKnowHowFold2.mobilePopUpImg
                              );
                            }}
                            style={hyperlinkSub}
                          >
                            Click here
                          </span>
                        </p>
                      )}
                    </Fade>
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            <div
              className={
                "w-100 stats-div " +
                (props?.fromBondsPage
                  ? "bg-color-mld"
                  : props?.fromMldPage
                  ? "bg-color-mld"
                  : "")
              }
            >
              <div className="section-max-width">
                <Col xs={12} lg={12} className="text-center">
                  <div className="info-block">
                    <Fade bottom="bottom" distance="50px">
                      <p className="block-title">
                        {props?.mldAssetDetails?.bondId === "gmldm0"
                          ? mldInvest.thirdFoldGoldMld.title
                          : props?.mldAssetDetails?.bondId === "gmld1" 
                          ? mldInvest.thirdFoldGoldMld1.title
                          : props?.mldAssetDetails?.bondId === "mld5"
                          ? mldInvest.mld5Fold.title
                          : mldInvest.secondFold.title}
                      </p>
                      <p className="block-subtitle">
                        {props?.mldAssetDetails?.bondId === "gmldm0" 
                          ? mldInvest.thirdFoldGoldMld.subTitle
                          : props?.mldAssetDetails?.bondId === "gmld1"
                          ? mldInvest.thirdFoldGoldMld1.subTitle
                          : props?.mldAssetDetails?.bondId === "mld5"
                          ? mldInvest.mld5Fold.subTitle
                          : mldInvest.secondFold.subtitle}
                      </p>
                    </Fade>
                  </div>
                </Col>
                <div
                  className="stats-fold invest-option"
                  style={{ maxWidth: "100%" }}
                >
                  {(props?.mldAssetDetails?.bondId === "gmldm0"
                    ? mldInvest.thirdFoldGoldMld.content
                    : props?.mldAssetDetails?.bondId === "gmld1"
                    ? mldInvest.thirdFoldGoldMld1.content
                    : props?.mldAssetDetails?.bondId === "mld5"
                    ? mldInvest.mld5Fold.content
                    : mldInvest.secondFold.content
                  ).map((item) => (
                    <Col
                      lg={3}
                      sm={12}
                      xs={12}
                      md={12}
                      className="d-flex flex-column stats-col"
                    >
                      <Row className="align-items-center invest-option-row">
                        <Media
                          src={item.imgSrc}
                          alt="alt-asset"
                          className="cards-img"
                        />
                        <div className="d-flex flex-column align-items-center content">
                          <div className="text-wrapper">
                            <p
                              className="subtext"
                              style={{ fontWeight: "800" }}
                            >
                              {item.text}
                            </p>
                            {item.showInfo && (
                              <>
                                <span
                                  onClick={handleHeadInfoClick}
                                  className="mdi mdi-information-outline ml-2"
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "15px",
                                  }}
                                />
                                <InfoPopup
                                  showPopUpText={showPopUpHead}
                                  toggleInfoPopup={handleHeadInfoClick}
                                  text={item.infoText}
                                />
                              </>
                            )}
                          </div>
                          <p className="text">{item.subtext}</p>
                          {item.seeHow && (
                            <div style={hyperDiv}>
                              {props.mldAssetDetails.bondId === "mld3" && (
                                <p
                                  style={hyperlink}
                                  onClick={() =>
                                    toggleImgPopUp(
                                      !isMobile
                                        ? item.popUpImg
                                        : item.mobileViewImage
                                    )
                                  }
                                >
                                  Click Here to See How
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      </Row>
                    </Col>
                  ))}
                </div>
                {props?.showSecondDiv ? (
                  <div className="stats-fold">
                    <div>
                      <p className="block-title">
                        {props.mldAssetDetails.bondId === "gmldm0" ? "60%" : props.mldAssetDetails.bondId === "gmld1" ? "37%" : props?.mldAssetDetails?.bondId === "mld5" ? "59%*" : "25%*"}
                        {props.mldAssetDetails.bondId === "gmldm0" || props.mldAssetDetails.bondId === "gmld1" ? <span
                          onClick={toggleNiftyPopup}
                          className="mdi mdi-information-outline ml-2"
                          style={{
                            cursor: "pointer",
                            fontSize: "15px",
                          }}
                        /> : null}
                      </p>
                      <p className="block-subtitle text-center">
                      {props.mldAssetDetails.bondId === "gmldm0" 
                        ? " Median returns of Magnifier MLD is 60% over the tenor of MLD v/s 53% investing directly in Gold ETF" 
                        : props.mldAssetDetails.bondId === "gmld1"
                        ? "Twin Win  MLD outperforms investment in Gold ETF on 37% of the occasions."
                        : props.mldAssetDetails.bondId === "mld5"
                        ? "NIFTY50 1.4 MLD outperforms investment in NIFTY50 on 59% of the occasions."
                        : "There is a 25% probability that Nifty 50 Index will give Negative Returns in 2 Years once it has reached an All-Time High"}
                      </p>
                    </div>
                    <div>
                      <p className="block-title">
                      {props.mldAssetDetails.bondId === "gmldm0" 
                        ? "50%" 
                        : props.mldAssetDetails.bondId === "gmld1" || props.mldAssetDetails.bondId === "mld5"
                        ? "Better risk adjusted return"
                        : "2.7x"}
                      {props.mldAssetDetails.bondId === "gmldm0" || props.mldAssetDetails.bondId === "gmld1" ? <span
                          onClick={props.mldAssetDetails.bondId === "gmldm0" || props.mldAssetDetails.bondId === "gmld1" ? toggleNiftyPopup: toggleSecondFold}
                          className="mdi mdi-information-outline ml-2"
                          style={{
                            cursor: "pointer",
                            fontSize: "15px",
                          }}
                        /> : null}
                      </p>
                      <p className="block-subtitle text-center">
                        {props.mldAssetDetails.bondId === "gmldm0" 
                          ? "Magnifier MLD outperforms investment in Gold ETF on 50% of the occasions."
                          : props.mldAssetDetails.bondId === "gmld1"
                          ? "Investing ₹1 in Twin Win Gold MLD yields ₹3.30, compared to ₹1.30 from the same investment in a Gold ETF."
                          : props.mldAssetDetails.bondId === "gmld1"
                          ? "Investing ₹1 in Twin Win Gold MLD yields ₹3.30, compared to ₹1.30 from the same investment in a Gold ETF."
                          : props.mldAssetDetails.bondId === "mld5"
                          ? "The Return per unit of risk for NIFTY 50 is 1.30x, whereas the same for NIFTY50 1.4 MLD is 2.10x."
                          : "2.7 times better Risk Adjusted Returns of InCred Nifty Balanced MLD Aug’25 v/s Nifty 50 Index"}
                      </p>
                    </div>
                  </div>
                ) : null}

                {props?.showSecondDiv ? (
                  <div className="info-block">
                    <Fade bottom="bottom" distance="50px">
                      {props.mldAssetDetails.bondId === "gmldm0"
                        ? null
                        : props.mldAssetDetails.bondId === "gmld1"
                        ? (
                          <p className="block-title">
                          Want to know how 100% Principal is protected at
                          Maturity? <br />
                          <span
                            onClick={() => {
                              toggleGraphPopUp(
                                !isMobile
                                  ? mldInvest.wantToKnowHowFoldGoldTwin.popUpImg
                                  : mldInvest.wantToKnowHowFoldGoldTwin.mobilePopUpImg
                              );
                            }}
                            style={hyperlinkSub}
                          >
                            Click here
                          </span>
                        </p>
                        ) : props.mldAssetDetails.bondId === "mld5" ? (
                          <p className="block-title">
                            Want to know how 100% Principal is protected at
                            Maturity? <br />
                            <span
                              onClick={() => {
                                toggleGraphPopUp(
                                  !isMobile
                                    ? mldInvest.wantToKnowHowFoldMld5.popUpImg
                                    : mldInvest.wantToKnowHowFoldMld5.mobilePopUpImg
                                );
                              }}
                              style={hyperlinkSub}
                            >
                              Click here
                            </span>
                          </p>
                        )
                        : <p className="block-title">Want to know how 100% Principal is protected at Maturity? <br />
                        <span
                          onClick={() => {
                            toggleGraphPopUp(
                              !isMobile
                                ? mldInvest.wantToKnowHowFold.popUpImg
                                : mldInvest.wantToKnowHowFold.mobilePopUpImg
                            );
                          }}
                          style={hyperlinkSub}
                        >
                          Click here
                        </span>
                      </p>}
                    </Fade>
                  </div>
                ) : null}
              </div>
            </div>
          )}
          <ImgPopup
            PopUpImg={PopUpImg}
            toggleImgPopUp={toggleImgPopUp}
            imgSrc={imgSrc}
          />
          <ImgPopup
            PopUpImg={popUpGraph}
            toggleImgPopUp={toggleGraphPopUp}
            imgSrc={graphSrc}
            isMobile={props?.isMobile}
          />
          <InfoPopup
            showPopUpText={popUp}
            toggleInfoPopup={toggleNiftyPopup}
            text={popText}
            nifty={true}
          />
          <PopUpSecondFold
            showPopUpText={popUpsecondFold}
            toggleInfoPopup={toggleSecondFold}
            isMobile={props.isMobile}
          />
        </>
      )
    );
}

export default SecondFold;
